import { useContext, useCallback, useRef, useEffect } from 'react';
import biLogger from '../BiLogger.logger';
import { BiContext } from '../BiLogger.context';
import ddt from '@wix/da-ddt';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { BiContextProvidedValue } from '../events/context';
const defaultContextFields = [
    'view',
    'component',
    'notification_message_id'
];
const ignoredFields = [
    '_biLoggerVersion',
    '_rankOffset',
    '_rankIndex',
    '_value'
];
export function mergeEventDataWithContext(eventData, context) {
    const mergedBiData = {
        evid: eventData.evid
    };
    // fill up the context stuff we always grab by default
    defaultContextFields.forEach((key)=>{
        if (context[key]) {
            mergedBiData[key] = context[key];
        }
    });
    // now add the data from the event itself, filling in anything that is supposed to come from context
    Object.keys(eventData).forEach((key)=>{
        // ignore internal use only fields
        if (ignoredFields.includes(key)) {
            return;
        }
        // pull values from context
        if (eventData[key] === BiContextProvidedValue) {
            // rank calculation
            if (key === 'rank') {
                var _eventData__rankIndex;
                const _rankIndex = (_eventData__rankIndex = eventData._rankIndex) !== null && _eventData__rankIndex !== void 0 ? _eventData__rankIndex : context._rankIndex;
                const _rankOffset = context._rankOffset;
                if (typeof _rankOffset !== 'undefined' && typeof _rankIndex !== 'undefined') {
                    mergedBiData[key] = _rankOffset + _rankIndex;
                    return;
                }
            }
            if (context[key]) {
                mergedBiData[key] = context[key];
            }
            return;
        }
        mergedBiData[key] = eventData[key];
    });
    return mergedBiData;
}
export function useBiLogger() {
    const biContext = useContext(BiContext);
    const publicSession = useContext(SessionContext);
    // The following is outright cheating the memoization system, but we want
    // to make sure logEvent is a single, stable instance. So instead of forcing
    // it to recreate the callback every time the contexts update to keep the
    // closure from going stale, we keep non-rerendering refs that provide the
    // latest values for it.
    const contextMemoForOptimization = useRef(biContext);
    const sessionMemoForOptimization = useRef(publicSession);
    useEffect(()=>{
        contextMemoForOptimization.current = biContext;
        sessionMemoForOptimization.current = publicSession;
    }, [
        biContext,
        publicSession
    ]);
    const logEvent = useCallback((eventData, sampling)=>{
        // bail if sampled and fails the random check.
        if (sampling && Math.random() > sampling) {
            ddt.log('bilogger', `(evid: ${eventData.evid})`, `sampled out, sampling rate ${sampling * 100}%`);
            return;
        }
        return biLogger.log(sessionMemoForOptimization.current, mergeEventDataWithContext(eventData, contextMemoForOptimization.current));
    }, []);
    return logEvent;
}

//# sourceMappingURL=useBiLogger.js.map